import { Component, Input, ViewChild } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CalendarService } from '../../Model/Calendar/calendar.service';
import { AttendanceService } from '../../Model/Attendance/attendance.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonModule, JsonPipe } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { MyteamsService } from '../../Model/Module/MyTeams/myteams.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AttendanceviewComponent } from '../attendanceview/attendanceview.component';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-reportee-attendance',
  standalone: true,
  imports: [CommonModule, NgChartsModule, FormsModule, NgbDatepickerModule, RouterModule, LoaderComponent, DataTablesModule, JsonPipe, NgSelectModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './reportee-attendance.component.html',
  styleUrl: './reportee-attendance.component.scss'
})
export class ReporteeAttendanceComponent {
  @Input() InputData: any;
  isDisabled: boolean = false;
  user: any;
  SumarryCount: any[] = [];
  SumarryList: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = []
  SiteId: any = null;
  ClientId: any = null;
  Filter = {
    FromDate: null as any,
    ToDate: null as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
    DateType: 'Today',
    selectedMonth: null as any,
    Today: null as any
  }
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    public activeModal: NgbActiveModal,
    private utility: UtilityService,
    private session: SessionService,
    protected common: CommonService,
    protected dateFromat: CustomDateParserFormatter,
    private modalService: NgbModal,
    private attendance: AttendanceService,
    private toast: ToastService,
    private Calendar: CalendarService,
    private myteam: MyteamsService,
  ) {
    this.user = this.session.GetUserDetails();
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit() {
    if (this.InputData.EmpType.toLowerCase() == 'front') {
      this.MyTeams('ClientMaster', this.InputData.ProfileID, '');
      this.ClientId = this.InputData.ClientID
      this.MyTeams('SiteMaster', this.InputData.ProfileID, '');
      this.SiteId = this.InputData.SiteID
    }
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.Today = response.Table[0].RegistrationDate;
          this.Filter.FromDateObj = this.dateFromat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFromat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.MyTeams('SummaryCount', this.InputData.ProfileID, '');
        this.MyTeams('SummaryList', this.InputData.ProfileID, '');

        // if (this.InputData.EmpType.toLowerCase() == 'front') {
        //   this.MyTeams('ClientMaster', this.InputData.ProfileID, '');
        //   this.ClientId = this.InputData.ClientID
        //   this.MyTeams('SiteMaster', this.InputData.ProfileID, '');
        //   this.SiteId = this.InputData.SiteID
        // }

        // this.MyTeams('SiteMaster', this.InputData.ProfileID, '');
      },
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }
  MyTeams(SelectType: String, EmpmasterID: any, AttendanceType: any) {
    this.isDisabled = true
    let previousDay = ''
    if (this.Filter.DateType == 'Yesterday') {
      const today = new Date(this.Filter.Today);
      today.setDate(today.getDate() - 1);
      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      };
      previousDay = today.toLocaleDateString('en-GB', options).replace(',', '');
    }
    const fromdate = this.dateFromat.format(this.Filter.FromDateObj);
    const todate = this.dateFromat.format(this.Filter.ToDateObj); 
    this.myteam.Mobile_ESS_MyTeam({
      EmpType: this.user.EmpType,
      SelectType: SelectType,
      EmpmasterID: EmpmasterID,
      FromDate: this.Filter.DateType == 'Today' ? this.Filter.Today : this.Filter.DateType == 'Yesterday' ? previousDay : this.Filter.DateType == 'Monthly' ? this.Filter.FromDate : this.Filter.DateType == 'Date' ? fromdate : this.Filter.DateType == 'DateRange' ? fromdate : this.Filter.Today,
      ToDate: this.Filter.DateType == 'Today' ? this.Filter.Today : this.Filter.DateType == 'Yesterday' ? previousDay : this.Filter.DateType == 'Monthly' ? this.Filter.ToDate : this.Filter.DateType == 'Date' ? fromdate : this.Filter.DateType == 'DateRange' ? todate : this.Filter.Today,
      SiteID: this.SiteId,//SelectType === 'SiteMaster' ? this.SiteId : 0,
      AttendanceType: AttendanceType,
      ClientID: this.ClientId //SelectType === 'SiteMaster' ? this.ClientId : 0
    }).subscribe({
      next: (response) => {
        if (SelectType === 'SummaryCount') {
          if (response.ESS_MyTeam_View.length > 0) {
            this.SumarryCount = response.ESS_MyTeam_View.map((item: any) => ({
              ...item,
              isSelect: false
            }))
          }
        } else if (SelectType === 'SummaryList') {
          if (response.ESS_MyTeam_View.length > 0) {
            this.SumarryList = response.ESS_MyTeam_View
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        } else if (SelectType === 'ClientMaster') {
          if (response.ESS_MyTeam_View.length > 0) {
            this.ClientLoad = response.ESS_MyTeam_View
          }
        } else if (SelectType === 'SiteMaster') {
          if (response.ESS_MyTeam_View.length > 0) {
            this.SiteLoad = response.ESS_MyTeam_View
          }
        }
        this.isDisabled = false
      },
      complete: () => { this.isDisabled = false },
      error: (error) => { this.isDisabled = false },
    });
  }

  convertColorToHex(color: string): string {
    // Remove '0x' or '0X' prefix
    if (color.toLowerCase().startsWith("0x")) {
      color = color.slice(2);
    }

    // Return as #RRGGBB (skip first 2 bytes = Alpha)
    return `#${color.slice(2)}`;
  }

  Close() {
    this.activeModal.close();
  }

  AttendanceView(element: any) {
    const modalRef = this.modalService.open(AttendanceviewComponent, { centered: true, backdrop: 'static', size: 'xl' });
    const shortPath = element.Photo ? element.Photo.split("/").slice(-2).join("/") : '';
    modalRef.componentInstance.InputData = {
      EmpmasterID: element.EmpMasterID,
      Photo: shortPath,//element.Photo,
      EmpName: element.FullName,
      EmpCode: element.EmpCode,
      DesignationName: element.DesignationName,
    }
    modalRef.result.then((result) => {

    }).catch((reason) => {
      console.log('Modal dismissed', reason)
    })
  }

  onNavigate() {
    const startFromDate = new Date(this.Filter.selectedMonth.year, this.Filter.selectedMonth.month - 1, 1);
    const endDate = new Date(this.Filter.selectedMonth.year, this.Filter.selectedMonth.month, 0);
    this.Filter.FromDate = startFromDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    this.Filter.ToDate = endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  onCardClick(element: any) {
    this.SumarryList = []
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.SumarryCount.forEach((card: any) => {
      card.isSelect = false;
    });
    //element.isSelect = true;
    element.isSelect = !element.isSelect;
    const selectedTypes = this.SumarryCount
      .filter((card: { isSelect: any; }) => card.isSelect)
      .map((card: { Type: string; }) => card.Type);
    const Types = selectedTypes ? selectedTypes.join(', ') : '';
    this.MyTeams('SummaryList', this.InputData.ProfileID, Types);
  }

  onChange() {
    this.SumarryCount = [
      {
        "Type": "Present",
        "Count": 0,
        "Color": "0XFF339900"
      },
      {
        "Type": "Absent",
        "Count": 0,
        "Color": "0xFFCC0000"
      },
      {
        "Type": "Half Day",
        "Count": 0,
        "Color": "0xFF33ffbd"
      },
      {
        "Type": "Week Off",
        "Count": 0,
        "Color": "0xFFd580ff"
      },
      {
        "Type": "Paid Leave",
        "Count": 0,
        "Color": "0XFFFF9900"
      },
      {
        "Type": "Comp off",
        "Count": 0,
        "Color": "0XFFFF9900"
      },
      {
        "Type": "Paid Holiday",
        "Count": 0,
        "Color": "0XFF33ADFF"
      },
      {
        "Type": "Miss Punch",
        "Count": 0,
        "Color": "0XFF862d86"
      }
    ]
    this.SumarryList = []
    this.SumarryCount.forEach((card: any) => {
      card.isSelect = false;
    });
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  ondropdownChange(type: string){
    if(type == 'ClientMaster'){
      this.SiteId = null
      this.SiteLoad = []
      this. onChange()
    }
  }
}

